import { LocationsType } from '../types';

/**
 * A list of all available top locations.
 */
export const TOP_LOCATIONS: LocationsType[] = ['top-start', 'top', 'top-end'];

/**
 * A list of all available top locations.
 */
export const CENTER_LOCATIONS: LocationsType[] = ['top', 'bottom'];

/**
 * The base styles for the toasts' tray.
 */
export const BASE_STYLE = {
    listStyle: 'none',
};
